/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    group: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    iconClass: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    licenseComponent: string;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof Event
     */
    readonly argTypes: { [key: string]: string | undefined; };
}

export function EventFromJSON(json: any): Event {
    return EventFromJSONTyped(json, false);
}

export function EventFromJSONTyped(json: any, ignoreDiscriminator: boolean): Event {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'group': json['group'],
        'iconClass': json['icon_class'],
        'licenseComponent': json['license_component'],
        'argTypes': json['arg_types'],
    };
}

export function EventToJSON(value?: Event | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'group': value.group,
        'icon_class': value.iconClass,
        'license_component': value.licenseComponent,
    };
}


